module.exports = __webpack_public_path__ + "static/positivity-15500e638f38039f2f74efed4d91bf68.png";